import { SegmentedControl } from 'cng-common/components/segmentedControl'
import { Translation } from 'cng-common/features/translations'

import {
  FINANCIAL_METRIC_MODE_OPTIONS,
  getMetricModeTranslationKey,
} from '../lib/getMetricModeTranslationKey'
import { resolveFinancialMetricMode } from '../lib/resolveFinancialMetricMode'
import type { FinancialMetricMode } from '../model/types'

interface MetricModeSwitchProps<T extends FinancialMetricMode> {
  selectedMode: T
  backgroudn?: 'bg-transparent' | 'bg-default' | 'bg-white'
  onModeChange: (mode: T) => void
  optionClassName?: string
  availableModes?: readonly FinancialMetricMode[]
}

export const MetricModeSwitch = <T extends FinancialMetricMode>({
  selectedMode,
  onModeChange,
  optionClassName,
  backgroudn = 'bg-default',
  availableModes,
}: MetricModeSwitchProps<T>) => {
  const resolvedAvailableModes =
    availableModes && availableModes.length > 0 ? availableModes : FINANCIAL_METRIC_MODE_OPTIONS

  return (
    <SegmentedControl
      useItemKeys
      size="small"
      rounded="rounded-full"
      backgroudn={backgroudn}
      variant="veneer"
      selectedItem={resolveFinancialMetricMode(selectedMode, resolvedAvailableModes)}
      onItemSelect={(value) => onModeChange(value as T)}
    >
      {FINANCIAL_METRIC_MODE_OPTIONS.filter((option) =>
        resolvedAvailableModes.includes(option)
      ).map((option) => (
        <SegmentedControl.Item key={option} itemKey={option}>
          <span className={optionClassName}>
            <Translation text={getMetricModeTranslationKey(option)} span />
          </span>
        </SegmentedControl.Item>
      ))}
    </SegmentedControl>
  )
}
